module.exports = __webpack_public_path__ + "img/explanation.560c2dc8.svg";